export class RtClmSightCode {
    constructor(public id: string, public name: string, public description: string) {}
}
